export const fakeProductDE = {
  images: {
    all: [
      {
        names: {
          name: '',
          lang: 'de',
          imageId: 23,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:109:placeholder.jpg',
        cleanImageName: 'productPlaceholder.jpg',
      },
    ],
    variation: [
      {
        names: {
          name: '',
          lang: 'de',
          imageId: 23,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:productPlaceholderjpg',
        cleanImageName: '109-productPlaceholder.jpg',
      },
      {
        names: {
          name: '',
          lang: 'de',
          imageId: 24,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:productPlaceholderjpg',
        cleanImageName: '109-productPlaceholder.jpg',
      },
    ],
  },
  item: {
    id: 109,
    storeSpecial: null,
    manufacturerId: 2,
    itemType: 'default',
    manufacturer: {
      name: 'Teston Testerton',
      legalName: 'Teston Testerton',
      logo: '',
      url: '',
      contactUrl: '',
      street: 'Teststreet',
      email: '',
      responsibleName: 'Teston Testerton',
      responsibleStreet: 'Teststreet',
      responsibleHouseNo: '1',
      responsiblePostCode: '12345',
      responsibleTown: 'New Test City',
      responsibleCountry: 1,
      responsibleEmail: '',
      responsibleContactUrl: '',
      responsiblePhoneNo: '',
      externalName: '',
      postcode: '54321',
      houseNo: '2',
      town: 'Testington',
      countryId: 1,
      phoneNumber: '',
      faxNumber: '',
      nameExternal: '',
      countryObject: {
        names: [
          { language: 'de', country_id: '1', name: 'Testcountry', id: 250 },
          { country_id: '1', language: 'de', id: 1, name: 'Testcountry' },
        ],
        shippingDestinationId: 101,
        active: 1,
        lang: 'de',
        name: 'Germany',
        id: 1,
        storehouseId: 0,
        isoCode3: 'DEU',
        isCountryStateMandatory: null,
        isoCode2: 'DE',
      },
      responsibleCountryObject: {
        names: [
          { language: 'de', country_id: '1', name: 'Germany', id: 250 },
          { country_id: '1', language: 'de', id: 1, name: 'Deutschland' },
        ],
        shippingDestinationId: 101,
        active: 1,
        lang: 'de',
        name: 'Germany',
        id: 1,
        storehouseId: 0,
        isoCode3: 'DEU',
        isCountryStateMandatory: null,
        isoCode2: 'DE',
      },
    },
    rebate: 0,
    salableVariationCount: 1,
    customsTariffNumber: '3303001000',
    producingCountry: {
      names: [],
    },
    condition: {
      names: [],
    },
  },
  texts: {
    urlPath: 'placeholderText',
    technicalData:
      'Das Feld „Technische Daten“ ermöglicht es Ihnen, zusätzliche detaillierte Informationen zu einem Produkt bereitzustellen. Es bietet die gleichen Formatierungsoptionen wie das Artikeltext-Feld.</br>Neben technischen Daten können Sie dieses Feld auch für andere Produktinformationen nutzen, die Sie gesondert hervorheben möchten, z. B.:<ul><li>Pflegehinweise bei Kleidung</li><li>Zutaten oder Nährwertangaben bei Lebensmitteln</li><li>Maße bei Möbeln</li><li>Weitere relevante Produktdetails</li></ul>',
    name3: 'Name 3 EN',
    title: 'HTML-Titel für Webshop DE',
    itemId: 128,
    id: 104,
    lang: 'de',
    description:
      "<p>Auf dieser Seite können Sie festlegen, wie Ihre Produktdetailseiten gestaltet werden sollen. Sie bestimmen selbst, welche Inhalte sichtbar sind, in welcher Reihenfolge diese erscheinen und wie umfangreich die Informationen sein sollen. Um die Bearbeitung zu starten, bewegen Sie die Maus über ein Element und<span style='color: purple'>klicken Sie auf den lilafarbenen Stift.</span></p>Das Feld, das Sie hier gerade sehen, ist der <span style='font-weight: bold'>Artikeltext</span>. Hierbei handelt es sich um einen Fließtext, der beliebig lang sein darf. Nutzen Sie diesen Platz, um Ihren Kundinnen und Kunden ausführliche Informationen zu Ihrem Produkt bereitzustellen, zum Beispiel besondere Merkmale oder Einsatzmöglichkeiten</br></br>Der Text, den Sie aktuell sehen, ist selbstverständlich nur ein Platzhaltertext. Er dient dazu, Ihnen zu veranschaulichen, an welcher Stelle die Produktbeschreibung auf der Produktdetailseite angezeigt wird und wie diese optisch eingebettet ist.</br></br>Die eigentlichen Artikeltexte verwalten Sie im Backend in der Artikelverwaltung. Dort stehen Ihnen zahlreiche Formatierungsmöglichkeiten zur Verfügung, mit denen Sie Ihre Inhalte ansprechend gestalten können, zum Beispiel:<ul><li>Einfügen von Links</li><li>Integration von kleinen Bildern oder Icons</li><li>Erstellen übersichtlicher Tabellen</li><li>Verwendung von Absätzen und Listen zur besseren Strukturierung</li><li>und vieles mehr.</li></ul></br>Nutzen Sie diese Funktionen, um Ihre Produktseiten individuell zu gestalten und ein überzeugendes Einkaufserlebnis zu schaffen.",
    metaDescription: 'Meta Description DE',
    name2: 'Beispielprodukt DE',
    name1: 'Beispielprodukt',
    shortDescription: 'Dies ist ein kurzer Vorschautext, der beispielsweise in Produktlisten verwendet werden kann.',
    keywords: 'Meta-Keywords DE',
  },
  variation: {
    itemId: 109,
    availabilityId: 1,
    maximumOrderQuantity: null,
    minimumOrderQuantity: 1,
    intervalOrderQuantity: 1,
    releasedAt: null,
    name: '',
    vatId: 0,
    weightG: 400,
    weightNetG: 300,
    widthMM: 650,
    lengthMM: 550,
    heightMM: 330,
    unitsContained: 1,
    bundleType: null,
    mayShowUnitPrice: true,
    availability: {
      id: 1,
      icon: 'av1.gif',
      averageDays: 2,
      createdAt: '2022-06-27 09:20:16',
      updatedAt: '2022-06-27 09:20:16',
      names: {
        id: 41,
        availabilityId: 1,
        lang: 'de',
        name: 'Sofort versandfertig, Lieferzeit 48h',
        createdAt: '2022-06-27 09:20:16',
        updatedAt: '2022-06-27 09:20:16',
      },
    },
    id: 1007,
    availabilityUpdatedAt: '2018-02-28T11:49:53+01:00',
    externalId: '54321',
    model: 'Testmodel',
  },
  filter: {
    isSalable: true,
    isSalableAndActive: true,
    hasActiveChildren: false,
    hasChildren: true,
  },
  unit: {
    names: {
      unitId: 1,
      lang: 'de',
      name: 'Stück',
    },
    unitOfMeasurement: 'C62',
    content: 1,
  },
  tags: [
    {
      id: 2,
      names: {
        name: 'NEU',
        lang: 'de',
      },
      color: '#0282a2',
    },
    {
      id: 3,
      names: {
        name: 'BELIEBT',
        lang: 'de',
      },
      color: '#a26d6d',
    },
  ],
  properties: [],
  hasOrderProperties: true,
  hasRequiredOrderProperty: true,
  groupedAttributes: [],
  prices: {
    default: {
      price: {
        value: 1000,
        formatted: '1.000,00 EUR',
      },
      unitPrice: {
        value: 1000,
        formatted: '1.000,00 EUR',
      },
      basePrice: '',
      baseLot: null,
      baseUnit: null,
      baseSinglePrice: null,
      minimumOrderQuantity: 1,
      contactClassDiscount: {
        percent: 0,
        amount: 0,
      },
      categoryDiscount: {
        percent: 0,
        amount: 0,
      },
      currency: 'EUR',
      lowestPrice: {
        value: null,
        formatted: '',
      },
      vat: {
        id: 0,
        value: 19,
      },
      isNet: false,
      data: {
        salesPriceId: 1,
        price: 1000,
        priceNet: 999,
        basePrice: 1000,
        basePriceNet: 999,
        unitPrice: 1000,
        unitPriceNet: 999,
        lowestPrice: null,
        lowestPriceNet: null,
        customerClassDiscountPercent: 0,
        customerClassDiscount: 0,
        customerClassDiscountNet: 0,
        categoryDiscountPercent: 0,
        categoryDiscount: 0,
        categoryDiscountNet: 0,
        vatId: 0,
        vatValue: 19,
        currency: 'EUR',
        interval: 'none',
        conversionFactor: 1,
        minimumOrderQuantity: '1.00',
        updatedAt: '2025-10-07 11:55:31',
        type: 'default',
        pricePosition: 0,
      },
    },
    rrp: {
      price: {
        value: 1200,
        formatted: '1.200,00 EUR',
      },
      unitPrice: {
        value: 1200,
        formatted: '1.200,00 EUR',
      },
      basePrice: '',
      baseLot: null,
      baseUnit: null,
      baseSinglePrice: null,
      minimumOrderQuantity: 0,
      contactClassDiscount: {
        percent: 0,
        amount: 0,
      },
      categoryDiscount: {
        percent: 0,
        amount: 0,
      },
      currency: 'EUR',
      lowestPrice: {
        value: null,
        formatted: '',
      },
      vat: {
        id: 0,
        value: 19,
      },
      isNet: false,
      data: {
        salesPriceId: 2,
        price: 1200,
        priceNet: 4201.6806722689,
        basePrice: 1200,
        basePriceNet: 4201.6806722689,
        unitPrice: 1200,
        unitPriceNet: 4201.6806722689,
        lowestPrice: null,
        lowestPriceNet: null,
        customerClassDiscountPercent: 0,
        customerClassDiscount: 0,
        customerClassDiscountNet: 0,
        categoryDiscountPercent: 0,
        categoryDiscount: 0,
        categoryDiscountNet: 0,
        vatId: 0,
        vatValue: 19,
        currency: 'EUR',
        interval: 'none',
        conversionFactor: 1,
        minimumOrderQuantity: '0.00',
        updatedAt: '2025-10-07 11:55:10',
        type: 'rrp',
        pricePosition: 0,
      },
    },
    set: null,
    specialOffer: null,
    graduatedPrices: [
      {
        price: {
          value: 900,
          formatted: '900,00 EUR',
        },
        unitPrice: {
          value: 900,
          formatted: '900,00 EUR',
        },
        basePrice: '',
        baseLot: null,
        baseUnit: null,
        baseSinglePrice: null,
        minimumOrderQuantity: 5,
        contactClassDiscount: {
          percent: 0,
          amount: 0,
        },
        categoryDiscount: {
          percent: 0,
          amount: 0,
        },
        currency: 'EUR',
        lowestPrice: {
          value: 1000,
          formatted: '1000,00 EUR',
        },
        vat: {
          id: 0,
          value: 19,
        },
        isNet: false,
        data: {
          salesPriceId: 3,
          price: 1000,
          priceNet: 999.2,
          basePrice: 1000,
          basePriceNet: 999.2,
          unitPrice: 1000,
          unitPriceNet: 999.2,
          lowestPrice: 1000,
          lowestPriceNet: 1000,
          customerClassDiscountPercent: 0,
          customerClassDiscount: 0,
          customerClassDiscountNet: 0,
          categoryDiscountPercent: 0,
          categoryDiscount: 0,
          categoryDiscountNet: 0,
          vatId: 0,
          vatValue: 19,
          currency: 'EUR',
          interval: 'none',
          conversionFactor: 1,
          minimumOrderQuantity: '5.00',
          updatedAt: '2025-10-07 11:56:02',
          type: 'default',
          pricePosition: 0,
        },
      },
    ],
  },
  bundleComponents: [],
  facets: [],
  attributes: [],
};
